var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type)?_c('span',{class:['odds-bet', { 'active_':_vm.isChange },{ 'active_0': _vm.increase === 0 }, { 'active_0': _vm.increase === 1 }]},[_vm._v(_vm._s(_vm.newOdds))]):_c('span',{class:['odds-txt', { 'active_':_vm.isChange },{ 'active_0': _vm.increase === 0 }, { 'active_1': _vm.increase === 1 }]},[_vm._v(_vm._s(_vm.newOdds))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22f09bcb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/build902/components/new-home/odds.vue
// module id = null
// module chunks = 